import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND_LOGO_FULL_SRC } from '../../config/brandAssets';
import { Card } from '../common';

interface AuthActionShellProps {
  children: React.ReactNode;
  heading: string;
  description: string;
  headingRef?: React.RefObject<HTMLHeadingElement>;
  statusProps?: React.HTMLAttributes<HTMLDivElement>;
}

const AuthActionShell: React.FC<AuthActionShellProps> = ({
  children,
  heading,
  description,
  headingRef,
  statusProps,
}) => {
  return (
    <main className="flex min-h-screen bg-primary-dark-100 px-4 py-6 text-primary-light-100 sm:px-6 sm:py-10">
      <div className="mx-auto flex w-full max-w-lg items-center">
        <Card className="w-full p-6 sm:p-8">
          <Link
            to="/"
            className="mb-6 inline-flex min-h-11 items-center rounded-lg focus-outline"
            aria-label="Ratuj Sprzęt — strona główna"
          >
            <img src={BRAND_LOGO_FULL_SRC} alt="" className="h-11 w-auto" />
          </Link>

          <div {...statusProps}>
            <h1
              ref={headingRef}
              tabIndex={-1}
              className="text-2xl font-bold text-primary-light-100 focus:outline-none"
            >
              {heading}
            </h1>
            <p className="mt-3 text-sm leading-6 text-primary-light-300">{description}</p>
          </div>

          <div className="mt-6">{children}</div>
        </Card>
      </div>
    </main>
  );
};

export default AuthActionShell;
